import React, { useState, useEffect } from 'react';
import { X, Heart } from 'lucide-react';
import ReleaseCard from './ReleaseCard';

const Watchlist = ({ onClose }) => {
  const [watchlist, setWatchlist] = useState([]);

  const loadWatchlist = () => {
    const saved = JSON.parse(localStorage.getItem('watchlist') || '[]');
    setWatchlist(saved);
  };

  useEffect(() => {
    loadWatchlist();

    // Listen for watchlist updates
    const handleUpdate = () => loadWatchlist();
    window.addEventListener('watchlistUpdated', handleUpdate);

    return () => {
      window.removeEventListener('watchlistUpdated', handleUpdate);
    };
  }, []);

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-start justify-center overflow-y-auto p-4">
      <div className="relative w-full max-w-6xl bg-gradient-to-br from-[#E3F2FD] via-[#BBDEFB] to-[#90CAF9] rounded-2xl shadow-2xl my-8">
        {/* Header */}
        <div className="sticky top-0 bg-black text-white p-6 rounded-t-2xl flex items-center justify-between z-10">
          <div className="flex items-center gap-3">
            <Heart className="w-6 h-6 text-red-500 fill-red-500" />
            <h2 className="font-primary text-2xl md:text-3xl uppercase tracking-wide">
              My Watchlist
            </h2>
          </div>
          <button
            onClick={onClose}
            data-testid="close-watchlist"
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {watchlist.length === 0 ? (
            <div className="text-center py-16">
              <Heart className="w-16 h-16 mx-auto mb-4 text-gray-600" />
              <h3 className="font-primary text-2xl uppercase mb-2 text-black">
                Your Watchlist is Empty
              </h3>
              <p className="font-secondary text-gray-700">
                Add shows and movies you want to watch by clicking the heart icon
              </p>
            </div>
          ) : (
            <>
              <p className="font-secondary text-gray-800 mb-6">
                {watchlist.length} {watchlist.length === 1 ? 'item' : 'items'} in your watchlist
              </p>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 md:gap-8">
                {watchlist.map((release) => (
                  <ReleaseCard key={release.id} release={release} />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Watchlist;
